export interface StatusHistoryListKeyArguments {
  approvalId: string;
}

export const statusHistoryKeys = {
  all: ["statusHistory"] as const,
  lists: () => [...statusHistoryKeys.all, "list"] as const,
  list: (arguments_: StatusHistoryListKeyArguments) =>
    [...statusHistoryKeys.lists(), arguments_] as const,
};
